import dicomParser from 'dicom-parser';

import { gigaBytesToBytes } from './files';

const defaultStatus = {
  files: [],
  hasReport: false,
  imageCount: 0,
  reportUploaded: false,
  study: null,
  uploaded: false,
  uploadedReport: [],
};

export default function parseFiles(files, currentStatus = null) {
  const status = { ...defaultStatus, ...(currentStatus || {}) };
  status.files = [];
  const promises = [];

  if (files && files.length) {
    const filesArray = Array.from(files);
    const dcomFiles = filesArray.filter((file) => {
      const parts = file.name.split('.');
      if (parts.length === 1) return true;
      return parts[parts.length - 1].toLowerCase() === 'dcm';
    });

    if (dcomFiles.length === 0) {
      throw new Error('The selected folder does not contain any study files');
    }

    const totalSize = dcomFiles.reduce((size, file) => file.size + size, 0);

    if (gigaBytesToBytes(1) < totalSize) {
      throw new Error('The selected folder is bigger than 1GB. Please use the online folder option for bigger files.');
    }

    status.imageCount = 0;

    status.uploaded = true;

    dcomFiles.forEach((file) => {
      status.files.push(file);
      promises.push(file.arrayBuffer());
    });

    return Promise.all(promises).then((result) => {
      const studyIds = new Set();
      const allItems = [];

      result.forEach((item) => {
        try {
          const byteArray = new Uint8Array(item);
          const dataSet = dicomParser.parseDicom(byteArray);

          const pixelDataElement = dataSet.elements.x7fe00010;
          status.imageCount += pixelDataElement && pixelDataElement.length ? 1 : 0;

          allItems.push(dataSet);
        } catch (ignore) {
          // eslint-disable-next-line no-console
          console.log('Parsing file failed');
        }
      });

      allItems.sort((a, b) => {
        try {
          const aStudy = a.string('x00081030');
          const bStudy = b.string('x00081030');

          if (aStudy > bStudy) return 1;
          if (aStudy < bStudy) return -1;
          return 0;
        } catch (ignore) {
          return 0;
        }
      });

      status.study = allItems?.[0]?.string('x00081030') || '';
      allItems.forEach((item) => {
        try {
          const studyId = item.string('x0020000d');
          if (studyId) studyIds.add(studyId);
        } catch (ignore) {
          //
        }
      });

      if (studyIds.size === 0) throw new Error('The selected folder does not contain any study files');
      if (studyIds.size > 1) {
        const studyWording = studyIds.size > 2 ? 'studies' : 'study';
        status.study = `${status.study || 'No Title'} (+${studyIds.size - 1} ${studyWording})`;
      }

      return status;
    });
  }

  return null;
}
